import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { trackClick } from "@/lib/analytics";

const LINKS = [
  { label: "Le partenariat", to: "/#partenariat" },
  { label: "L'Agilité", to: "/agilite" },
  { label: "Nos offres", to: "/#offres" },
  { label: "FlashDiag", to: "/flashdiag" },
  { label: "Quiz", to: "/quizz" },
  { label: "Livre blanc", to: "/livre-blanc" },
];

export const BrandMark = ({ small = false }) => (
  <Link to="/" data-testid="brand-logo" className="flex items-baseline gap-2 font-heading">
    <span className={`font-bold tracking-tight text-slate-50 ${small ? "text-base" : "text-lg"}`}>ASAP</span>
    <span className="grad-text font-extrabold text-xl leading-none">×</span>
    <span className={`font-bold tracking-tight text-slate-50 ${small ? "text-base" : "text-lg"}`}>REQEN</span>
  </Link>
);

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (to) => {
    setOpen(false);
    if (to.startsWith("/#")) {
      const id = to.slice(2);
      if (location.pathname !== "/") {
        navigate("/");
        setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 350);
      } else {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate(to);
    }
  };

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#0b0f19]/90 backdrop-blur-xl border-b border-white/5" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <BrandMark small />
        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.label}
              data-testid={`nav-${l.label.toLowerCase().replace(/['\s]/g, "-")}`}
              onClick={() => go(l.to)}
              className="text-sm text-slate-400 hover:text-slate-100 transition-colors"
            >
              {l.label}
            </button>
          ))}
          <button data-testid="nav-cta" onClick={() => { trackClick("nav_contact"); go("/#contact"); }} className="btn-primary !px-5 !py-2.5">
            Prendre contact
          </button>
        </nav>
        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-slate-200"
          onClick={() => setOpen(!open)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div className="md:hidden bg-[#0b0f19] border-b border-white/10 px-6 py-4 space-y-3">
          {LINKS.map((l) => (
            <button
              key={l.label}
              onClick={() => go(l.to)}
              className="block w-full text-left text-sm text-slate-300 py-2"
            >
              {l.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
}
